/**
 * Created by Rodrigo Quesada on 16/02/17.
 */
import {Component} from '@angular/core';
import {LifeCertificationService} from '../../../../domain/model/licenses-certifications/lifecertification/life-certification.service';
import {AccordionScreen} from '../../../shared/step/accordion/accordion-screen.class';
import {LifeCertification} from '../../../../domain/model/licenses-certifications/lifecertification/life-certification.model';
import {EntryWithSupportingDocument} from '../../../shared/step/accordion/entry.class';
import moment = require('moment');

//region Other Classes
class LifeCertificationEntry extends EntryWithSupportingDocument<LifeCertification> {
    constructor(esdm: EntryWithSupportingDocument.InjectedMembers, model: LifeCertification) {
        super(esdm, model, 'lifeCertification');
    }
}
//endregion

@Component({
    template: require('./life-certification-screen.component.html')
})
export class LifeCertificationScreenComponent extends AccordionScreen<LifeCertificationEntry, LifeCertification> {

    constructor(esdm: EntryWithSupportingDocument.InjectedMembers, modelService: LifeCertificationService) {
        super(LifeCertification, (m) => new LifeCertificationEntry(esdm, m), 'certificationType', modelService);
    }

    certificationTypes: Array<string> = ['BLS', 'ACLS', 'PALS', 'ATLS'];

    expirationDateConstrains = {
        min: moment().subtract(5, 'year'),
        max: moment().add(20, 'year'),
    };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/steps/lifecertification/life-certification-screen.component.ts